module.exports = __webpack_public_path__ + "static/raluca-poiana-741381aca6e51f39523461b3afa78c72.jpg";